import * as yup from "yup";

export const loginSchema = yup.object().shape({
	email: yup.string().email("Введите корректный email").required("Заполните email"),
	password: yup.string().required("Заполните пароль"),
});
